<template>
  <div class="container">
    <b-modal hide-footer hide-header ref="modalCodeReader" size="xl" no-close-on-backdrop no-close-on-esc centered
      body-class="p-0" @hidden="onModalClose()">
      <div class="camera-fullscreen">
        <WebCam id="webcam-codereader" ref="webcam" :device-id="deviceId" @started="onStarted" @error="onError"
          @cameras="onCameras" @notsupported="onNotsupported" @camera-change="onCameraChange" />
        <div class="div-select-camera">
          <select v-if="devices.length > 1" class="select-camera" v-model="camera">
            <option v-for="device in devices" :key="device.deviceId" :value="device.deviceId">
              {{ device.label }}
            </option>
          </select>
          <select v-if="scannerOptions.length > 1" class="select-camera" v-model="readType" @change="onScanTypeChange">
            <option v-for="scannOption in scannerOptions" :key="scannOption" :value="scannOption">
              {{ scanTypeDescriptions[scannOption] }}
            </option>
          </select>
          <b-button @click="closeModal()" class="button-camera" variant="danger">Encerrar</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>


<script>
import { BrowserQRCodeReader } from '@zxing/browser';
import Quagga from 'quagga';
import ComponentMixin from '../../core/ComponentMixin';
import { WebCam } from "vue-web-cam";
import { BModal, BButton } from 'bootstrap-vue';

export default {
  name: "ClicCodeReader",
  mixins: [ComponentMixin],
  components: { WebCam, BModal, BButton },
  data() {
    return {
      public: {
        startScan: this.startScan
      },
      img: null,
      camera: null,
      deviceId: null,
      qrCodeControls: null,
      devices: [],
      qrCodeReader: new BrowserQRCodeReader(),
      scanner: [],
      readType: "",
      barCodeIsRunning: false,
      scanTypeDescriptions: {
        QRCODE: "QR Code",
        BARCODE: "Barras"
      },
    };
  },
  created() {
    this.scannerOptions = this.scannerOptions?.split(" ") || []
    this.readType = this.scannerOptions[0] ? this.scannerOptions[0] : ""
  },
  computed: {
    device: async function () {
      return this.devices.find(n => n.deviceId === this.deviceId);
    }
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: async function () {
      try {
        const storedCameraId = this.obtemCameraStorage();

        let stream;
        if (storedCameraId) {
          stream = await navigator.mediaDevices.getUserMedia({
            video: { deviceId: { exact: storedCameraId } }
          });
        } else {
          stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: { exact: "environment" } }
          });
        }

        const [videoTrack] = stream.getVideoTracks();
        const cameraId = videoTrack.getSettings().deviceId;

        this.defineCameraStorage(cameraId)

        this.camera = cameraId;
        this.deviceId = cameraId;

      } catch (error) {
        console.error("Erro ao acessar a câmera:", error);

        const [first, ...tail] = this.devices.slice().reverse();

        if (first) {
          this.camera = first.deviceId;
          this.deviceId = first.deviceId;
          this.defineCameraStorage(first.deviceId)
        }
      }
    }
  },


  methods: {
    obtemCameraStorage() {
      let storageData = JSON.parse(localStorage.getItem("config")) || {}
      const storedCameraId = storageData[this.idTela]?.[this.cp.id]?.cameraSelecionada || null
      console.log("Camera local", storedCameraId)
      return storedCameraId
    },
    defineCameraStorage(deviceId) {
      let objLocalStorage = JSON.parse(localStorage.getItem("config")) || {};

      if (!objLocalStorage[this.idTela]) {
        objLocalStorage[this.idTela] = {};
      }

      if (!objLocalStorage[this.idTela][this.cp.id]) {
        objLocalStorage[this.idTela][this.cp.id] = {};
      }

      objLocalStorage[this.idTela][this.cp.id].cameraSelecionada = deviceId;
      localStorage.setItem("config", JSON.stringify(objLocalStorage));
    },
    onCodeScan($scanned) {
      if (this.lodash.has(this.cp, 'events.onCodeScan')) {
        this._execEvent('onCodeScan', { $scanned });
      }
      this.onModalClose()
      this.closeModal()
    },
    onScanTypeChange() {
      this.stopBarCodeReader();
      this.stopQrReader();

      if (this.readType === "QRCODE") {
        this.initializeQrCode();
      } else if (this.readType === "BARCODE") {
        this.initializeBarCode();
      }
    },
    startScan() {
      if (this.scannerOptions && this.scannerOptions.length) {
        this.$refs.modalCodeReader.show();
      } else {
        console.log("[ClicCodeReader] Nenhuma opção de escaneamento foi habilitada. Não foi possível abrir o Scanner.")
      }
    },
    stopQrReader() {
      if (this.qrCodeControls) {
        this.qrCodeControls.stop();
      }
    },
    stopBarCodeReader() {
      if (Quagga) {
        try {
          Quagga.stop();
          Quagga.offDetected(this.onDetectedCallback);
          this.barCodeIsRunning = false
        } catch (error) {
        }
      }
    },
    stopCamera() {
      this.deviceId = ""
    },
    onModalClose() {
      this.stopCamera();
      this.stopQrReader()
      this.stopBarCodeReader();
    },
    closeModal() {
      this.$refs.modalCodeReader.hide();
      this.onModalClose();
    },

    async initializeQrCode() {
      await this.$nextTick();
      const selectedDeviceId = this.deviceId;
      const previewElem = document.querySelector('#webcam-codereader > video');

      this.qrCodeControls = await this.qrCodeReader.decodeFromVideoDevice(selectedDeviceId, previewElem, (result, error, controls) => {
        if (result) {
          let objScan = {
            type: "QRCODE",
            data: {
              code: result.text || ""
            }
          }
          this.onCodeScan(objScan);
        }
      });
    },

    async initializeBarCode() {
      await this.$nextTick();
      const previewElem = document.querySelector('#webcam-codereader');

      if (!this.barCodeIsRunning) {
        Quagga.init({
          inputStream: {
            name: "Live",
            type: "LiveStream",
            target: previewElem
          },
          decoder: {
            readers: this.barCodeTypes.split(/[,\s]+/)
          },
          configs: {
            numOfWorkers: 16,
          }
        }, (err) => {
          if (err) {
            console.log(err);
            return
          }
          Quagga.start();
          this.onDetectedCallback = (barCode) => {
            let objScan = {
              type: "BARCODE",
              data: {
                code: barCode.codeResult.code || ""
              }
            }
            this.onCodeScan(objScan);
          };
          Quagga.onDetected(this.onDetectedCallback);

        });
        this.barCodeIsRunning = true;
      }
    },

    onStarted() {
      this.onScanTypeChange();
    },
    onError(error) {
      console.log("[ClicCodeReader] Não foi possível iniciar a câmera. ", error);
    },
    onNotsupported() {
      console.log("[ClicCodeReader] Câmera não suportada neste dispositivo.")
    },
    onCameras(cameras) {
      this.devices = cameras;
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
    }
  }
}
</script>

<style scoped>
.camera-fullscreen {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.div-select-camera {
  position: absolute;
  bottom: 10px;
  align-items: center;
  display: flex;
}

.select-camera {
  border-radius: 5px;
  padding: 5px;
  background-color: #f3f3f3ed;
  max-width: 120px;
  border: none;
  margin-left: 5px;
}

.button-camera {
  border-radius: 5px;
  border: none;
  margin-left: 5px;
}

#webcam-codereader {
  height: 100%;
  object-fit: cover;
}
</style>
